
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { RadioQuestion as RadioQuestionType } from "./types";
import { QuestionTooltip } from "./QuestionTooltip";

interface RadioQuestionProps {
  question: RadioQuestionType;
  value: string;
  onChange: (questionId: string, value: string) => void;
}

export function RadioQuestion({
  question,
  value,
  onChange
}: RadioQuestionProps) {
  return (
    <div className="space-y-8 w-full max-w-4xl mr-auto py-4 min-h-[400px] text-left">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-3">{question.title}</h2>
        
        {question.description && <p className="text-muted-foreground">{question.description}</p>}
        
        {question.tooltip && <QuestionTooltip tooltip={question.tooltip} />}
      </div>
      
      <RadioGroup value={value || ""} className="grid grid-cols-1 gap-3 mt-6" onValueChange={value => onChange(question.id, value)}>
        {question.options?.map(option => (
          <div 
            key={option.value} 
            onClick={() => onChange(question.id, option.value)} 
            className="option-card flex items-center space-x-3 p-4 border border-border hover:border-primary hover:bg-muted/50 transition-all cursor-pointer w-full max-w-2xl px-[10px] rounded-md mx-[10px] py-[6px]"
          >
            <RadioGroupItem value={option.value} id={option.value} className="transition-all" />
            <Label htmlFor={option.value} className="text-base font-medium cursor-pointer">
              {option.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
}
